import { render, staticRenderFns } from "./FoodcourtMenuList.vue?vue&type=template&id=02e88254&scoped=true"
import script from "./FoodcourtMenuList.vue?vue&type=script&lang=js"
export * from "./FoodcourtMenuList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtMenuList.vue?vue&type=style&index=0&id=02e88254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e88254",
  null
  
)

export default component.exports